import React from 'react'
import PropTypes from 'prop-types'
import { Col, Row } from 'react-styled-flexboxgrid'
import _ from 'lodash'
import { Link } from 'gatsby'
import * as styles from './styles'
import { Section, Markdown } from '..'

const propTypes = {
  header: PropTypes.string.isRequired,
  solutions: PropTypes.array.isRequired,
}

const IndustrySolutions = ({ header, solutions }) => {
  return (
    <styles.Container>
      <styles.SubContainer>
        <Row>
          <Col xs={12}>
            <styles.BlockHeader>
              {header}
            </styles.BlockHeader>
          </Col>
        </Row>
        <Section>
          <styles.CenteredRow>
            {_.map(solutions, (solution, i) => {
              const isAccounting = solution.id === 'accounting'
              return (
                <styles.ItemCol 
                  lg={isAccounting ? 5 : 4}
                  md={isAccounting ? 6 : 6} 
                  sm={12}
                  xs={12} 
                  key={solution.id}
                  featured={solution.featured}
                >
                  <styles.SolutionCard featured={solution.featured}>
                    <Link to={solution.url}>
                      <styles.CardContent>
                        {solution.icon && (
                          <styles.IconWrapper featured={solution.featured}>
                            <styles.Icon 
                              src={solution.icon.publicURL} 
                              alt="" 
                              featured={solution.featured}
                            />
                          </styles.IconWrapper>
                        )}
                        <styles.CardHeader featured={solution.featured}>
                          {solution.header}
                        </styles.CardHeader>
                        <styles.CardText>
                          <Markdown>
                            {solution.text}
                          </Markdown>
                        </styles.CardText>
                        {solution.useCases && (
                          <styles.UseCasesList>
                            {_.map(solution.useCases, (useCase, index) => (
                              <styles.UseCaseItem key={index}>
                                • {useCase}
                              </styles.UseCaseItem>
                            ))}
                          </styles.UseCasesList>
                        )}
                        {solution.demoImage && (
                          <styles.DemoImageContainer>
                            <styles.DemoImage 
                              src={solution.demoImage.publicURL} 
                              alt={`${solution.header} demo screenshot`}
                            />
                          </styles.DemoImageContainer>
                        )}
                        {solution.customerLogos && (
                          <styles.CustomerLogosSection>
                            <styles.CustomerLogosLabel>Trusted by:</styles.CustomerLogosLabel>
                            <styles.CustomerLogosContainer>
                              {_.map(solution.customerLogos, (logo, index) => (
                                <styles.CustomerLogo key={index}>
                                  <img src={logo} alt="Customer logo" />
                                </styles.CustomerLogo>
                              ))}
                            </styles.CustomerLogosContainer>
                          </styles.CustomerLogosSection>
                        )}
                        <styles.LearnMoreText featured={solution.featured}>
                          Learn more →
                        </styles.LearnMoreText>
                      </styles.CardContent>
                    </Link>
                  </styles.SolutionCard>
                </styles.ItemCol>
              )
            })}
          </styles.CenteredRow>
        </Section>
      </styles.SubContainer>
    </styles.Container>
  )
}

IndustrySolutions.propTypes = propTypes

export default IndustrySolutions